import React from 'react'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import i18n from 'live/services/i18n'
import {MAP_LIGHT } from 'plugin-extension-google/shared/GoogleMaps/LayersMenu';

import locale from 'live/init/global-locale'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'
import { Message, State } from './types'
import { reducer } from './reducer'
import WidgetCoverageMap from './WidgetCoverageMap'
import ConfigForm from './ConfigForm';
import './style.scss'

var localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}

i18n.add(localeFiles[locale])

widgetService.register({
    type: 'WidgetCoverageMap',
    get name() {
        return i18n('Widget Coverage Map')
    },
    get description() {
        return i18n('...')
    },
    config: {
        zoom: 15,
        mapType: MAP_LIGHT.id,
        extensionQualifier: ''
    },
    ui: { configForm: ConfigForm },
    policies: { handleOwnMissingData: true },    
    impl: reactWidgetWrapper<State, Message>(WidgetCoverageMap, reducer)
})
